import React, { useEffect } from 'react';
import { CustomRedirect } from '@/components/navigation';
import SessionStorage from '@/SessionStorage';
import { useSelector } from 'react-redux';
import { clearBuyerPermissions } from '@/state/buyer/permissions/actions';
import { LoadingIndicator } from '@ygtechnologies/bygr-frontend-component-library';
import { IState } from '@/state/IState';
import { useHistory, useLocation } from 'react-router';
import { useAppDispatch } from '@/utils/hooks';

export const ImpersonateBuyer: React.FC<{ residentialUnitId: number }> = ({ residentialUnitId }) => {
    SessionStorage.impersonationResidentialUnitId = residentialUnitId;

    return <CustomRedirect to="/" />;
};

export const EndBuyerImpersonation: React.FC = () => {
    SessionStorage.impersonationResidentialUnitId = null;

    const dispatch = useAppDispatch();
    const history = useHistory();
    const location = useLocation();
    const buyerPermissions = useSelector((state: IState) => state.buyer.permissions);

    const urlParams = new URLSearchParams(location.search);
    const returnUrl = urlParams.get('returnUrl');

    useEffect(() => {
        dispatch(clearBuyerPermissions());
    }, [dispatch]);

    useEffect(() => {
        if (!buyerPermissions) {
            const redirectPath = returnUrl || '/';
            history.replace(redirectPath);
        }
        dispatch(clearBuyerPermissions());
    }, [dispatch, history, buyerPermissions, returnUrl]);

    return <LoadingIndicator />;
};
